import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';

import classes from './Service.module.css';
import DataTable from '../../components/DataTable/DataTable';
import * as actions from '../../store/actions/index';
import Loader from '../../components/UI/Loader/Loader';
import { formatDateTime } from '../../store/utilities';

class TabTires extends Component {
    state = {
        tableOptions: {
            initialPage: 0,
            pageSize: 5,
            searchText: '',
            defaultSort: { column: null, order: '' },
        },
    };

    componentDidMount() {
        this.props.onGetTires(-1);
    }

    getTiresFields = () => {
        let tableFields = [
            {
                title: 'Date performed',
                field: 'datePerformed',
                render: (rowData) => formatDateTime(rowData.datePerformed),
                defaultSort: this.state.tableOptions.defaultSort.column === 0 ? this.state.tableOptions.defaultSort.order : null,
            },
            {
                title: 'Gse',
                field: 'gseName',
                render: (rowData) => rowData.gseName,
                defaultSort: this.state.tableOptions.defaultSort.column === 1 ? this.state.tableOptions.defaultSort.order : null,
            },
            {
                title: 'Airport',
                field: 'airportName',
                render: (rowData) => rowData.airportName,
                defaultSort: this.state.tableOptions.defaultSort.column === 2 ? this.state.tableOptions.defaultSort.order : null,
            },
            {
                title: 'Manufacturer',
                field: 'manufacturer',
                render: (rowData) => rowData.manufacturer,
                defaultSort: this.state.tableOptions.defaultSort.column === 3 ? this.state.tableOptions.defaultSort.order : null,
            },
            {
                title: 'Model',
                field: 'model',
                render: (rowData) => rowData.model,
                defaultSort: this.state.tableOptions.defaultSort.column === 4 ? this.state.tableOptions.defaultSort.order : null,
            },
            {
                title: 'Job status',
                field: 'jcdStatusDescr',
                render: (rowData) => rowData.jcdStatusDescr,
                defaultSort: this.state.tableOptions.defaultSort.column === 5 ? this.state.tableOptions.defaultSort.order : null,
            },
            {
                title: 'Record ID',
                render: (rowData) => (rowData.recordid1 === null ? '' : rowData.recordid1),
                defaultSort: this.state.tableOptions.defaultSort.column === 6 ? this.state.tableOptions.defaultSort.order : null,
            },
            {
                title: 'Record ID 2',
                render: (rowData) => (rowData.recordid2 === null ? '' : rowData.recordid2),
                defaultSort: this.state.tableOptions.defaultSort.column === 7 ? this.state.tableOptions.defaultSort.order : null,
            },
            {
                title: 'Car ID',
                render: (rowData) => (rowData.carid === null ? '' : rowData.carid),
                defaultSort: this.state.tableOptions.defaultSort.column === 8 ? this.state.tableOptions.defaultSort.order : null,
            },
        ];

        return tableFields;
    };

    gotoDetails = (rowData) => {
        const selectedGseId = rowData.gseId;

        this.props.onUpdateGseDataProperty('selectedGseId', selectedGseId);
        this.props.onClearGseEditDetails();
        this.props.gotoGse();
    };

    updateTableOptions = (property, value) => {
        let tableOptions = { ...this.state.tableOptions };
        tableOptions[property] = value;

        this.setState({ tableOptions: tableOptions });
    };

    render() {
        const tiresFields = this.getTiresFields();

        let page = (
            <Scrollbars style={{ width: '100%', height: '100%' }}>
                <div className={classes.ScrollInner}>
                    <Loader show={this.props.loading} />
                </div>
            </Scrollbars>
        );

        if (this.props.loading === false) {
            page = (
                <Scrollbars style={{ width: '100%', height: '100%' }}>
                    <div className={classes.ScrollInner}>
                        <DataTable
                            data={this.props.filtered_tiresRecords}
                            columns={tiresFields}
                            viewClicked={(rowData) => {
                                this.gotoDetails(rowData);
                            }}
                            withExport
                            withSearch
                            tableOptions={this.state.tableOptions}
                            updateTableOptions={(property, value) => this.updateTableOptions(property, value)}
                        />
                    </div>
                </Scrollbars>
            );
        }

        return page;
    }
}

const mapStateToProps = (state) => {
    return {
        loggedInUser: state.login.loggedInUser,
        filtered_tiresRecords: state._data.filtered_tiresRecords,
        loading: state._system.loading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onGetTires: (id) => dispatch(actions.getTires(id)),
        onUpdateGseDataProperty: (property, value) => dispatch(actions.updateGseDataProperty(property, value)),
        onClearGseEditDetails: () => dispatch(actions.clearGseEditDetails()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TabTires);
